import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../../constants/typography';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  orderInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: isKiteUser ? 'Helvetica' : 'Proxima Nova',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    fontStyle: 'normal',
    boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
    borderRadius: '10px',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(1.5),
  },
  orderInfoHeader: {
    fontWeight: isKiteUser ? FONT_WEIGHT_BOLD : FONT_WEIGHT_SEMIBOLD,
    fontSize: '14px',
    marginBottom: theme.spacing(0.5),
  },
  orderInfoText: {
    fontSize: '14px',
  },
  shippingMethod: {
    width: '220px',
    [theme.breakpoints.down('lg')]: {
      width: '224px',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        width: '224px',
      }),
    },
  },
}));
